<template>
  <div
    id="user-register"
    ref="registerPage"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="加载中"
  >
    <!-- <HeadView v-if="$store.getters.isPC"></HeadView>
    <MobileHeadView v-else></MobileHeadView>-->
    <div class="register-wrap" style="background: rgb(0 0 0 / 54%);">
      <!-- 图形验证码 -->
      <div id="imgCode">
        <VueCode
          :show="showCode"
          @onSuccess="handleCodeSuccess"
          @onClose="showCode = false"
          :imgs="puzzleImgList"
        />
      </div>
      <!-- 图形验证码 -->
      <div class="register-content width">
        <p style="text-align: center; font-size: 20px;">完善信息</p>
        <div class="register-form">
          <!-- <p class="register-title" v-if="!showNext">手机号码</p> -->
          <p class="register-title" v-if="showNext && !isExist">完善信息</p>
          <p class="register-title" v-if="showNext && isExist">此号码已经注册账号，请输入密码登录</p>
          <el-form :model="form" :rules="formRules" ref="form" size="small" v-if="!showNext">
            <el-form-item prop="phone" class="form-line">
              <span class="china-tel">中国 +86</span>
              <el-input v-model="form.phone" placeholder="请输入手机号码" clearable></el-input>
            </el-form-item>
            <el-form-item prop="code" class="form-line">
              <el-input v-model="form.code" placeholder="请输入验证码" clearable></el-input>
              <span class="code-button" @click="getCode" v-if="sendTime < 0">获取验证码</span>
              <span class="code-button" style="cursor: default;" v-else>重新发送({{this.sendTime}})</span>
            </el-form-item>
            <el-form-item prop="checked" class="form-line">
              <div style="display: flex; line-height: 1.5; margin-top: -3px;">
                <el-checkbox fill="#606266" style="margin-right: 10px;" v-model="form.checked"></el-checkbox>
                <p style="font-size: 14px;">
                  <span @click="form.checked = !form.checked">我已阅读并同意飞利浦健康生活俱乐部</span>
                  <span class="service" @click="toTerms">《会员服务协议》</span>及
                  <span class="service" @click="toPrivacy">《隐私政策》</span>
                </p>
              </div>
            </el-form-item>
            <!-- <el-form-item class="form-line">
              <div style="display: flex; align-items: center; line-height: 1;">
                <span>已有账号？</span>
                <router-link to="/login" target="_blank" class="exsit-login">登录</router-link>
              </div>
            </el-form-item>-->
            <div class="form-line">
              <span class="step-next" @click="next">下一步</span>
            </div>
          </el-form>
          <el-form
            :model="form"
            :rules="formRules"
            ref="form"
            size="small"
            v-if="showNext && isExist"
          >
            <el-form-item prop="password" class="form-line">
              <el-input v-model="form.password" type="password" placeholder="登录密码" clearable></el-input>
            </el-form-item>
            <div class="form-line">
              <span class="step-next" style="margin-bottom: 20px;" @click="loginSubmit">登录</span>
              <span class="step-next2" @click="forgetToLogin">忘记密码</span>
            </div>
          </el-form>
          <el-form
            :model="form"
            :rules="formRules"
            ref="form"
            size="small"
            v-if="showNext && !isExist"
          >
            <el-form-item prop="username" class="form-line">
              <el-input v-model="form.username" maxlength="30" placeholder="用户名" clearable></el-input>
            </el-form-item>
            <el-form-item prop="password" class="form-line">
              <el-input v-model="form.password" type="password" placeholder="登录密码" clearable></el-input>
            </el-form-item>
            <el-form-item prop="rePassword" class="form-line">
              <el-input v-model="form.rePassword" type="password" placeholder="确认密码" clearable></el-input>
            </el-form-item>
            <div class="form-line">
              <span class="step-next" style="margin-bottom: 20px;" @click="submitForm('form')">提交信息</span>
              <span class="step-next2" @click="showNext = false">上一步</span>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <!-- <FooterView v-if="$store.getters.isPC"></FooterView>
    <MobileFooterView v-else></MobileFooterView>-->
    <DialogToast v-if="isShowDialogToast" :id="testId" />
  </div>
</template>

<script>
import HeadView from '@/components/Head'
import MobileHeadView from '@/components/MobileHead'
import FooterView from '@/components/Footer'
import MobileFooterView from '@/components/MobileFooter'
import DialogToast from '@/components/DialogToast'
import VueCode from '../components/vue-code/code'
import request from '@/assets/js/request'
export default {
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号码'))
      } else {
        if (/^1[3456789]\d{9}$/i.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入登录密码'))
      } else if (value.length < 6 || value.length > 16) {
        return callback(new Error('请输入6-16位之间的登录密码'))
      } else {
        if (this.form.password !== '') {
          this.$refs.form.validateField('rePasswords')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入确认密码'))
      } else if (value.length < 6 || value.length > 16) {
        return callback(new Error('请输入6-16位之间的确认密码'))
      } else if (value !== this.form.password) {
        return callback(new Error('两次密码输入不一致!'))
      } else {
        callback()
      }
    }
    var check = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请勾选《会员服务协议》及《隐私政策》'))
      } else {
        callback()
      }
    }
    return {
      fullscreenLoading: false,
      form: {
        username: '',
        phone: '',
        password: '',
        rePassword: '',
        code: '',
        checked: false
      },
      phone: '',
      isExist: false, // 号码是否已经注册
      showNext: false, // 是否显示下一步内容
      formRules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: ['blur', 'change']
          }
        ],
        phone: [{ validator: checkPhone, trigger: ['blur', 'change'] }],
        password: [{ validator: validatePass, trigger: ['blur', 'change'] }],
        rePassword: [{ validator: validatePass2, trigger: ['blur', 'change'] }],
        code: [
          {
            required: true,
            message: '请输入手机验证码',
            trigger: ['blur', 'change']
          }
        ],
        checked: [{ validator: check, trigger: 'change' }]
      },
      puzzleImgList: [
        require('../assets/images/code/philips_history.jpg'),
        require('../assets/images/code/philips_hq.jpg'),
        require('../assets/images/code/philips_office.jpg'),
        require('../assets/images/code/philips_prod.jpg'),
        require('../assets/images/code/philips_shanghai.jpg')
      ],
      showCode: false,
      sendTime: -1,
      timer: null,
      isShowDialogToast: false,
      testId: 3
    }
  },
  components: {
    HeadView,
    MobileHeadView,
    FooterView,
    MobileFooterView,
    DialogToast,
    VueCode
  },
  methods: {
    toLogin () {
      this.$router.push('/login')
    },
    toTerms () {
      this.testId = 3
      this.isShowDialogToast = true
    },
    showDialogToast () {
      this.isShowDialogToast = false
    },
    toPrivacy () {
      this.testId = 2
      this.isShowDialogToast = true
    },
    forgetToLogin () {
      this.$router.push('/login?isForget=1')
    },
    getCode () {
      this.$refs.form.validateField('phone', (errMsg) => {
        if (!errMsg) {
          this.showCode = true
        }
      })
      // if (!/^1[3456789]\d{9}$/i.test(this.form.phone)) {
      //   this.message('请输入正确的手机号')
      // } else {
      //   this.showCode = true
      // }
    },
    next () {
      if (!this.$store.getters.yiBanUserInfo.userid) return this.message('授权失败，请重新登陆!', 'success')
      this.phone = this.form.phone // 将手机号存起来，因为跳下一步之后，form.phone会变成空，phone没办法传
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.fullscreenLoading = true
            console.log('access_token-' + localStorage.getItem('access_token'))
            await request('/gateway/users/users/member/ybPhoneLogin', 'post', {
              phone: this.form.phone,
              code: this.form.code,
              accessToken: localStorage.getItem('access_token'),
              yibanId: this.$store.getters.yiBanUserInfo.userid // 易班的用户id
            })
              .then((res) => {
                this.fullscreenLoading = false
                this.$refs.form.resetFields()
                if (res.data.flag) { // 如果有信息静默登录
                  this.$store.commit('SET_STATUS', true)
                  this.$store.commit('SET_INFO', res.data.member)
                  localStorage.setItem('token', res.data.member.memberToken)
                  localStorage.setItem('isForm', 1) // 1易班0正常来源
                  this.message('登录成功!', 'success')
                  this.$parent.registerBox = false // 注册隐藏
                } else {
                  this.showNext = true
                  this.isExist = false // 未注册，显示完善资料
                }
              })
          } catch (e) {
            this.fullscreenLoading = false
          }
        }
      })
    },
    // 注册完成登录
    submitForm () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.fullscreenLoading = true
            console.log('access_token-' + localStorage.getItem('access_token'))
            await request('/gateway/users/users/member/ybPhoneRegLogin', 'post', {
              password: this.form.password,
              phone: this.phone,
              username: this.form.username,
              accessToken: localStorage.getItem('access_token'),

              yibanId: this.$store.getters.yiBanUserInfo.userid, // 易班的用户id
              yb_username: this.$store.getters.yiBanUserInfo.yb_username,
              yb_sex: this.$store.getters.yiBanUserInfo.yb_sex,
              yb_userhead: this.$store.getters.yiBanUserInfo.yb_userhead,
              yb_schoolid: this.$store.getters.yiBanUserInfo.yb_schoolid,
              yb_schoolname: this.$store.getters.yiBanUserInfo.yb_schoolname
            })
              .then((res) => {
                this.$store.commit('SET_STATUS', true)
                this.$store.commit('SET_INFO', res.data)
                localStorage.setItem('token', res.data.memberToken)
                localStorage.setItem('isForm', 1) // 1易班0正常来源
                this.fullscreenLoading = false
                this.message('提交成功!', 'success')

                this.$parent.registerBox = false // 注册隐藏
              })
          } catch (e) {
            this.fullscreenLoading = false
          }
        }
      })
    },
    async bindMethods () {
      try {
        this.fullscreenLoading = true
        let res = await request(
          '/gateway/users/users/member/bindMessage',
          'post',
          {
            password: this.form.password,
            phone: this.phone,
            username: this.form.username
          }
        )
        this.fullscreenLoading = false
        this.message('绑定成功!', 'success')
        this.$store.commit('SET_STATUS', true)
        this.$store.commit('SET_INFO', res.data)
        localStorage.setItem('token', res.data.memberToken)
        this.$router.push('/index')
      } catch (e) {
        this.fullscreenLoading = false
      }
    },
    loginSubmit () {
      this.$refs.form.validateField('password', (errMsg) => {
        if (!errMsg) {
          this.loginMethods()
        }
      })
    },
    async loginMethods () {
      try {
        this.fullscreenLoading = true
        await request('/gateway/users/users/member/login', 'post', {
          password: this.form.password,
          phone: this.phone
        })
          .then((res) => {
            this.fullscreenLoading = false
            this.$store.commit('SET_STATUS', true)
            this.$store.commit('SET_INFO', res.data)
            localStorage.setItem('token', res.data.memberToken)
            this.$router.push('/index')
          })
          .catch((err) => {
            this.fullscreenLoading = false
            if (err.code == '2300') {
              this.$router.push(`/fill-info?phone=${this.phone}`)
            }
          })
      } catch (e) {
        this.fullscreenLoading = false
      }
    },
    async handleCodeSuccess () {
      this.showCode = false
      // 调取获取验证码接口
      try {
        this.fullscreenLoading = true
        await request('/gateway/users/users/member/getPhoneCode', 'get', {
          phone: this.form.phone
        })
        this.fullscreenLoading = false
        this.message('发送成功!', 'success')
        this.sendTime = 60
        this.timer = setInterval(() => {
          this.sendTime--
          if (this.sendTime < 0) {
            clearInterval(this.timer)
          }
        }, 1000)
      } catch (error) {
        this.fullscreenLoading = false
      }
    }
  },
  // 注册/完善信息监控是相同的
  // 代码监控开始
  mounted () {
    let head = document.querySelector('head')
    // function页面需要再加三个meta
    let meta1 = document.createElement('meta')
    meta1.name = 'PHILIPS.METRICS.CATALOGTYPE'
    meta1.content = 'register'
    let meta2 = document.createElement('meta')
    meta2.name = 'PHILIPS.METRICS.PAGETYPE'
    meta2.content = 'content'
    let meta3 = document.createElement('meta')
    meta3.name = 'PHILIPS.METRICS.PAGENAME'
    meta3.content = 'register'
    /* eslint-disable */
    try {
      setTimeout(() => {
        philips.analytics.trackAjax({
          pagename: 'register'
        })
      }, 2000)
    } catch (error) {}
    /* eslint-enable */
    head.insertBefore(meta1, head.children[7])
    head.insertBefore(meta2, head.children[7])
    head.insertBefore(meta3, head.children[7])
  },
  destroyed () {
    this.$removeMeta.removeFunctionMeta()
  }
  // 代码监控结束
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/css/mixin';
.register-wrap {
  background: #0000008a;
  position: fixed;
  padding: 0;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  touch-action: none;
  z-index: 998;
  .register-content {
    max-width: 600px !important;
    background: #fff;
    padding: 50px 0;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .register-form,
    .el-form {
      .service {
        color: $blue;
        cursor: pointer;
      }
      .service:hover {
        text-decoration: underline;
      }
      .step-next,
      .step-next2 {
        width: 100%;
        display: block;
        background: $blue;
        color: #fff;
        text-align: center;
        padding: 10px 0;
        cursor: pointer;
        line-height: 1.5;
      }
      .step-next2 {
        color: #000;
        background: #fff;
        border: 1px solid #dcdfe6;
        padding: 9px 0;
      }
      .step-next:hover {
        opacity: 0.8;
      }
      .step-next2:hover {
        border: 1px solid $blue;
      }
    }
    .exsit-login {
      color: #2b86b2;
      cursor: pointer;
    }
    .exsit-login:hover {
      text-decoration: underline;
    }
  }
}
</style>
<style lang="scss">
.register-wrap {
  .el-input__inner {
    border-radius: 0;
  }
  .form-line {
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterBox.vue